<script lang="ts">
    import Fa from 'svelte-fa'
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import { clearSession } from '../../session';
    import { openPushPopup, canAskPush } from '../../push';
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faHome,faWallet,faMoneyBillTransfer,faClockRotateLeft,faHandHoldingDollar,faFutbolBall,faCogs,faBell } from '@fortawesome/free-solid-svg-icons';

    import Time from "svelte-time";
    import Swal from 'sweetalert2'

    let balance = 0.00
    let acc_name =""

    let numnoti = ''

    async function getBalance() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getbalance", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            balance = json.payload.balance.toLocaleString('th-TH')
            acc_name = json.payload.username
		} else {
            clearSession();
            push('/')
            throw new Error(json);
		}
    }
    getBalance()

    async function checkPromotion() {
        let couponx = ""
        Swal.fire({
            title: "กรุณาระบุกรอก Code",
            input: "text",
            inputAttributes: {
                autocapitalize: "off",
                align: "center"
            },
            showCancelButton: true,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showLoaderOnConfirm: true,
            preConfirm: async (login) => {
                try {
                    couponx = login
                    const res = await fetch(window.localStorage.getItem("apiurl")+"member/getpromotioncode", {
                        method: 'POST',
                        headers:{
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                            'x-api-appid': window.localStorage.getItem("appid")
                        },
                        body: qs.stringify({
                            _id:login
                        })
                    })
                    const json = await res.json()
                    return json
                } catch (error) {
                    Swal.showValidationMessage(`
                        Request failed: ${error}
                    `);
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            
            if (result.isConfirmed) {
                // Swal.fire({
                // title: `${result.value.login}'s avatar`,
                // imageUrl: result.value.avatar_url
                // });
                if(result.value.statusCode == 200){
                    window.localStorage.setItem("coupon",couponx)
                    push('/promotion/'+result.value.payload._id)
                    
                }else{
                    window.localStorage.setItem("coupon","")
                    Swal.fire(result.value.message)
                }
            }else{
                
            }
        });
    }

    async function countMessage() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/countmessage", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            if(json.payload.total>=1){
                numnoti = json.payload.total
            }else{
                numnoti = ''
            }
            
		} else {
            throw new Error(json);
		}
    }
    // countMessage()

    let isRank = false
    let rankname = ""
    let rankimg = ""
    let percentagex = 0

    async function getRank() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getranking", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            if(json.payload.status){
                rankname = json.payload.rank_name
                rankimg = json.payload.rank_img
                let setA = json.payload.up_max-json.payload.up_min
                let setB = json.payload.scores-json.payload.up_min
                percentagex = Math.ceil((100*setB)/setA)
                isRank = true
            } 
		} else {
            
		}
    }
    getRank()

    // เปิดแอป auto_minigame: ขอ launch token + url จาก xapi แล้วเปิดในแท็บใหม่
    async function launchMinigame() {
        const token = window.localStorage.getItem('access_token')
        if(!token){
            Swal.fire('กรุณาเข้าสู่ระบบก่อนเล่นเกม')
            return
        }
        // เปิดแท็บไว้ก่อน await (กัน popup blocker) แล้วค่อยเซ็ต url หลังได้ token
        const win = window.open('', '_blank')
        try{
            const res = await fetch(window.localStorage.getItem("apiurl")+"v2/minigame/launch", {
                method: 'POST',
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Bearer '+token,
                    'x-api-appid': window.localStorage.getItem("appid")
                },
                body: qs.stringify({})
            })
            const json = await res.json()
            if(json.statusCode==200 && json.payload && json.payload.url){
                if(win){ win.location.href = json.payload.url }
                else { window.open(json.payload.url, '_blank') }
                return
            }
            if(win){ win.close() }
            Swal.fire((json && json.message) || 'ไม่สามารถเปิดเกมได้')
        }catch(err){
            if(win){ win.close() }
            Swal.fire('เกิดข้อผิดพลาด ลองใหม่อีกครั้ง')
        }
    }
</script>


    <div class="navbar fixed-bottom bg-transparent p-0">
        <div class="container content-wrapper bg-warMain " style="position: relative;" >
            <!-- <div style="position: absolute;right: 6px;width: 35px;top: -80px;background: #FFF;padding: 2px 1px 3px 1px;border-radius: 20px;border:1px solid #c1a305;">
                <img src="./assets/images/promote.png" class="img-fluid" style="max-height: 30px;cursor:pointer;" on:click={() => push('/message')}>
                {#if numnoti!=''}
                <span class="position-absolute ps-1 pe-1 top-0 start-75  translate-middle bg-danger border border-light rounded-pill text-white text-center" >
                    {numnoti}
                    <span class="visually-hidden">New alerts</span>
                  </span>
                  {/if}
            </div> -->
            {#if isRank}
            <div style="position: absolute;right: 6px;width: 35px;top: -85px;background: #FFF;padding: 2px 1px 3px 1px;border-radius: 20px;border:1px solid #c1a305;">
                <img src="{rankimg}" class="img-fluid" style="max-height: 30px;cursor:pointer;" on:click={() => push('/ranking')}>
            </div>
            <div style="position: absolute;right: 6px;width: 35px;top: -55px;padding: 2px 1px 3px 1px;">
                <div class="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="{percentagex}" aria-valuemin="0" aria-valuemax="100" style="height: 0.5rem;">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-info" style="width: {percentagex}%"><span style="font-size: 0.4rem;">{percentagex}%</span></div>
                </div>
            </div>
            
            {/if}
            <div style="position: absolute;right: 6px;width: 35px;top: -40px;background: #FFF;padding: 2px 1px 3px 1px;border-radius: 20px;border:1px solid #c1a305;">
                <img src="./assets/images/giftbox.png" class="img-fluid" style="max-height: 30px; cursor:pointer;" on:click={() => checkPromotion()}>
            </div>
            {#if canAskPush()}
            <div class="pushnoti" style="position: absolute;left: 4px;top: -45px;" on:click={() => openPushPopup()} role="button" tabindex="0">
                <span class="pushnoti-disc">
                    <span class="pushnoti-ring"></span>
                    <span class="pushnoti-core"><Fa icon={faBell} /></span>
                    <span class="pushnoti-spark">✦</span>
                </span>
                <span class="pushnoti-label">แจ้งเตือน</span>
            </div>
            {/if}
            <div class="spin-fab" on:click={() => launchMinigame()} role="button" tabindex="0">
                <div class="spin-fab-badge">
                    <span class="spin-fab-icon">
                        <svg viewBox="0 0 24 24" width="30" height="30" xmlns="http://www.w3.org/2000/svg">
                            <g stroke="#fff" stroke-width="0.6" stroke-linejoin="round">
                                <path d="M12 12 L23 12 A11 11 0 0 1 19.78 19.78 Z" fill="#e23b3b"/>
                                <path d="M12 12 L19.78 19.78 A11 11 0 0 1 12 23 Z" fill="#f6c54a"/>
                                <path d="M12 12 L12 23 A11 11 0 0 1 4.22 19.78 Z" fill="#e23b3b"/>
                                <path d="M12 12 L4.22 19.78 A11 11 0 0 1 1 12 Z" fill="#f6c54a"/>
                                <path d="M12 12 L1 12 A11 11 0 0 1 4.22 4.22 Z" fill="#e23b3b"/>
                                <path d="M12 12 L4.22 4.22 A11 11 0 0 1 12 1 Z" fill="#f6c54a"/>
                                <path d="M12 12 L12 1 A11 11 0 0 1 19.78 4.22 Z" fill="#e23b3b"/>
                                <path d="M12 12 L19.78 4.22 A11 11 0 0 1 23 12 Z" fill="#f6c54a"/>
                            </g>
                            <circle cx="12" cy="12" r="11" fill="none" stroke="#fff3c4" stroke-width="1.2"/>
                            <circle cx="12" cy="12" r="2.4" fill="#fff" stroke="#d68a00" stroke-width="0.8"/>
                        </svg>
                    </span>
                    <span class="spin-fab-spark s1">✨</span>
                    <span class="spin-fab-spark s2">⭐</span>
                    <span class="spin-fab-spark s3">✨</span>
                </div>
                <span class="spin-fab-label">หมุนฟรี</span>
            </div>
            <div class="row p-0" style="background-color: black;background: linear-gradient(135deg, rgb(0 0 0) 0%, rgb(86 80 80) 50%, rgb(131 120 120) 51%, rgb(54 50 50) 71%, rgb(0 0 0) 100%);">
                <div class="d-flex flex-row p-0 text-center justify-content-around pt-2 pb-1">
                    <div class="w-20  m-0 p-0 btn-footer text-center" on:click={() => push('/dashboard')} >
                        
                        <img src="./assets/icon/home_v2.png" class="img-fluid" style="max-height: 30px;"><br />
                        หน้าแรก
                    </div>
                    <div class="w-20  m-0 p-0 btn-footer text-center" on:click={() => push('/deposit')}>
                        <img src="./assets/icon/deposit_v2.png" class="img-fluid" style="max-height: 30px;"><br />
                        ฝาก
                    </div>
                    <div class="w-20  m-0 p-0 btn-footer text-center " style="position: relative;">
                        <button type="button" on:click={() => getBalance()} class="bigbtn rounded-circle"><Fa icon={faHandHoldingDollar} size="2x"/><br/>{balance}</button>
                    </div>
                    <div class="w-20  m-0 p-0 btn-footer text-center" on:click={() => push('/withdraw')}>
                        <img src="./assets/icon/withdraw_v2.png" class="img-fluid" style="max-height: 30px;"><br />
                        ถอน
                    </div>
                    <div class="w-20  m-0 p-0 btn-footer text-center" on:click={() => push('/promotion')}>
                        <img src="./assets/icon/history_v2.png" class="img-fluid" style="max-height: 30px;"><br />
                        โปรโมชั่น
                    </div>
                    
                </div>
                
            </div>
            

        </div>
    </div>
<style>
    .navbar>.content-wrapper, .content-wrapper{
		/* width: 373px!important;
    	max-width: 374px!important; */
		min-height: 100%;
		display: table;
	}

    /* ===== ปุ่มลอย "หมุนฟรี" (เปิด auto_minigame) ===== */
    .spin-fab{
        position: absolute;
        right: 2px;
        top: -195px;
        width: 56px;
        text-align: center;
        cursor: pointer;
        z-index: 20;
        animation: spinfab-floaty 2.4s ease-in-out infinite;
        -webkit-tap-highlight-color: transparent;
    }
    .spin-fab-badge{
        position: relative;
        width: 50px;
        height: 50px;
        margin: 0 auto;
        border-radius: 50%;
        background: radial-gradient(circle at 30% 30%, #fff4cf 0%, #f3c64a 38%, #d68a00 100%);
        border: 2px solid #fff3c4;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 0 8px rgba(246,197,74,.7);
        animation: spinfab-glow 1.6s ease-in-out infinite;
    }
    .spin-fab-icon{
        font-size: 26px;
        line-height: 1;
        display: inline-block;
        animation: spinfab-rotate 3.2s linear infinite;
        filter: drop-shadow(0 1px 1px rgba(0,0,0,.3));
    }
    .spin-fab-spark{
        position: absolute;
        font-size: 12px;
        pointer-events: none;
        opacity: 0;
        animation: spinfab-twinkle 1.4s ease-in-out infinite;
    }
    .spin-fab-spark.s1{ top: -6px; right: -4px; animation-delay: 0s; }
    .spin-fab-spark.s2{ bottom: -6px; left: -6px; font-size: 10px; animation-delay: .5s; }
    .spin-fab-spark.s3{ top: 50%; right: -10px; animation-delay: .9s; }
    .spin-fab-label{
        display: inline-block;
        margin-top: 3px;
        padding: 1px 8px;
        font-size: .62rem;
        font-weight: 700;
        color: #3a2400;
        white-space: nowrap;
        border-radius: 10px;
        background: linear-gradient(135deg,#ffe9a8 0%,#f6c54a 50%,#e0a000 100%);
        box-shadow: 0 1px 4px rgba(0,0,0,.5);
        border: 1px solid #fff3c4;
    }
    @keyframes spinfab-glow{
        0%,100%{ box-shadow: 0 0 6px rgba(246,197,74,.6); }
        50%{ box-shadow: 0 0 18px rgba(255,214,90,1); }
    }
    @keyframes spinfab-rotate{ to{ transform: rotate(360deg); } }
    @keyframes spinfab-twinkle{
        0%,100%{ opacity: 0; transform: scale(.4); }
        50%{ opacity: 1; transform: scale(1.1); }
    }
    @keyframes spinfab-floaty{
        0%,100%{ transform: translateY(0); }
        50%{ transform: translateY(-4px); }
    }
    @media (prefers-reduced-motion: reduce){
        .spin-fab, .spin-fab-badge, .spin-fab-icon, .spin-fab-spark{ animation: none; }
    }
    .w-20{
        width: 18%!important;
        width: 70px;
    }
    .btn-footer{
        color: white;
        background-color: transparent;
        border: 0px;
        cursor: pointer;
    }
   .bigbtn{
        background: linear-gradient(180deg, #ecc857 0%, #cf8000 100%);
        /* position: absolute; */
        width: 75px;
        height: 75px;
        position: absolute;
        left: 0px;
        top:-30px;
        color:white;
   }

   @media only screen and (min-device-aspect-ratio:1920 / 1080){
        .navbar>.content-wrapper, .content-wrapper{
            width: 373px!important;
            max-width: 374px!important;
            min-height: 100%;
            display: table;
        }

	}
	@media only screen and (min-device-aspect-ratio:512/683){
		.navbar>.content-wrapper, .content-wrapper{
            width: 373px!important;
            max-width: 374px!important;
            min-height: 100%;
            display: table;
        }
	}

    /* ===== ปุ่ม "แจ้งเตือน" (กระดิ่งหมุน) วางแนวเดียวกับกล่องของขวัญ ===== */
    .pushnoti{
        width: 35px;
        text-align: center;
        cursor: pointer;
        z-index: 20;
        -webkit-tap-highlight-color: transparent;
    }
    .pushnoti-disc{
        position: relative;
        width: 27px;
        height: 27px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .pushnoti-ring{
        position: absolute;
        inset: -2px;
        border-radius: 50%;
        border: 1.5px dashed #ffe9a8;
        animation: pushnoti-spin 5s linear infinite;
    }
    .pushnoti-core{
        width: 27px;
        height: 27px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .72rem;
        color: #4a3500;
        background: radial-gradient(circle at 50% 35%, #fff3cf 0%, #e6c477 60%, #d4ad55 100%);
        box-shadow: 0 2px 7px rgba(0,0,0,.4);
        animation: pushnoti-glow 1.8s ease-in-out infinite;
    }
    .pushnoti-spark{
        position: absolute;
        top: -3px;
        right: -3px;
        color: #fff;
        font-size: .4rem;
        text-shadow: 0 0 5px #fff, 0 0 8px #ffe9a8;
        opacity: 0;
        pointer-events: none;
        animation: pushnoti-twinkle 1.6s ease-in-out infinite;
    }
    .pushnoti-label{
        display: inline-block;
        margin-top: 2px;
        padding: 0 5px;
        font-size: .5rem;
        font-weight: 700;
        color: #fff;
        background: rgba(0,0,0,.45);
        border-radius: 6px;
        text-shadow: 0 0 4px rgba(0,0,0,.6);
        white-space: nowrap;
    }
    @keyframes pushnoti-spin { to { transform: rotate(360deg); } }
    @keyframes pushnoti-glow {
        0%,100%{ box-shadow: 0 2px 7px rgba(0,0,0,.4), 0 0 0 0 rgba(230,196,119,.5); }
        50%{ box-shadow: 0 2px 10px rgba(0,0,0,.4), 0 0 10px 4px rgba(230,196,119,.45); }
    }
    @keyframes pushnoti-twinkle {
        0%,100%{ opacity: 0; transform: scale(.4) rotate(0deg); }
        50%{ opacity: 1; transform: scale(1.15) rotate(90deg); }
    }
</style>
